import { useTranslation } from 'react-i18next';
import { AgentState, useAgentState } from '../hooks/useAgentState';
import styles from './AgentStatusBadge.module.scss';

type AgentStatus =
  | 'talking'
  | 'listening'
  | 'thinking'
  | 'waiting'
  | 'loading';

function getBadgeStatus(agentState: AgentState): AgentStatus {
  switch (agentState) {
    case 'speaking':
      return 'talking';
    case 'listening':
      return 'listening';
    case 'thinking':
      return 'thinking';
    case 'waiting':
      return 'waiting';
    case 'idle':
      return 'loading';
  }
}

export function AgentStatusBadge() {
  const { t } = useTranslation();
  const { agentState } = useAgentState();
  const status = getBadgeStatus(agentState);

  return (
    <div className={styles.agentStatusBadge} data-status={status}>
      <span className={styles.statusLabel}>
        {t(`aiInterview.agentStatus.${status}`)}
      </span>
    </div>
  );
}
